// TODO: Convert this file to TypeScript and export proper type definitions
// This will allow consuming packages (like datatable) to import the BrowserStorage type
// instead of defining their own inline interface
import _ from 'lodash'
const ADAPTERS = {
  LOCAL_STORAGE: 'local_storage',
  COOKIE: 'cookie',
}

class PersistentBrowserStorage {
  static ADAPTERS = ADAPTERS

  constructor(options = {}) {
    this._options = options

    if (_.values(ADAPTERS).indexOf(options.adapter) === -1) {
      throw new Error(
        `Invalid adapter option specified.  Must be one of: ${_.values(
          ADAPTERS
        ).join(', ')}`
      )
    }

    this._adapter = options.adapter

    if (this.isCookieAdapter()) {
      if (_.isEmpty(options.provider)) {
        throw new Error(
          'You must provide a cookie provider when implementing a cookie adapter'
        )
      }
      this._provider = options.provider
    } else if (this.isLocalStorageAdapter()) {
      this._provider = window.localStorage
    }
  }

  isCookieAdapter = () => this._adapter === ADAPTERS.COOKIE

  isLocalStorageAdapter = () => this._adapter === ADAPTERS.LOCAL_STORAGE

  getValue = name => {
    if (this.isCookieAdapter()) {
      return this._provider.get(name)
    }

    if (this.isLocalStorageAdapter()) {
      return JSON.parse(this._provider.getItem(name))
    }
  }

  setValue = (name, value) => {
    if (this.isCookieAdapter()) {
      return this._provider.set(name, value, { path: '/' })
    }

    if (this.isLocalStorageAdapter()) {
      return this._provider.setItem(name, JSON.stringify(value))
    }
  }

  removeValue = name => {
    if (this.isCookieAdapter()) {
      try {
        return this._provider.remove(name)
      } catch (e) {
        console.warn(
          'Error removing cookie, please check your cookie adapter has the remove method',
          e
        )
      }
    }

    if (this.isLocalStorageAdapter()) {
      return this._provider.removeItem(name)
    }
  }
}

export default PersistentBrowserStorage
